import { createReducer } from "@reduxjs/toolkit";
import { CHANGE_ADMIN_VIEW_SECTION } from "actions/types";
import { AdminViewTabs } from "constants/AdminViewConstants";

const initialState = {
  section: AdminViewTabs.USER_SUMMARY,
};

const adminViewReducer = createReducer(initialState, {
  [CHANGE_ADMIN_VIEW_SECTION]: (state, action) => {
    state.section = action.payload;
  },
});

export default adminViewReducer;
